import { type ClientOptions } from 'graphql-ws';
import { RelayWebSocketSubscriptionHandler, KEEP_ALIVE } from './RelayWebSocketSubscriptionHandler';
import { getWebSocketURL } from './getWebSocketURL';

let wsHandler: RelayWebSocketSubscriptionHandler | undefined;

/**
 * Gets or creates a singleton instance of RelayWebSocketSubscriptionHandler
 * @returns RelayWebSocketSubscriptionHandler instance
 */
export function getRelayWebSocketSubscriptionHandler(): RelayWebSocketSubscriptionHandler {
	const WEBSOCKET_URL = getWebSocketURL();
	if (!wsHandler) {
		wsHandler = new RelayWebSocketSubscriptionHandler({
			url: () => {
				return WEBSOCKET_URL;
			},
			shouldRetry: () => {
				return true;
			},
			keepAlive: KEEP_ALIVE, // ping server every 10 min
			retryAttempts: 5,
		});
	}

	return wsHandler;
}

/**
 * Creates a new RelayWebSocketSubscriptionHandler instance with custom options
 * @param options ClientOptions for the WebSocket client
 * @returns New RelayWebSocketSubscriptionHandler instance
 */
export function createRelayWebSocketSubscriptionHandler(
	options: ClientOptions,
): RelayWebSocketSubscriptionHandler {
	return new RelayWebSocketSubscriptionHandler(options);
}
